import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { IToast } from '../models/interfaces.model';

@Injectable()
export class NotificationService {
  private notificationSubject: ReplaySubject<IToast> = new ReplaySubject();
  public notification$: Observable<IToast> = this.notificationSubject.asObservable();

  constructor() {}

  public callNotification(notification: IToast): void {
    this.notificationSubject.next(notification);
  }
}
